import { toast } from "sonner";

import { ApiError } from "./http";

/**
 * The server refuses a decision with `clickup_auth_required` when the reviewer
 * has no usable ClickUp token, so writeback can't post under their identity.
 * Show a toast that lets them reconnect (re-run the ClickUp OAuth login) and
 * return true so the caller skips its generic error toast.
 */
export function handledClickupAuth(err: unknown): boolean {
  if (!(err instanceof ApiError) || err.message !== "clickup_auth_required") {
    return false;
  }
  toast.error("Reconnect ClickUp to record this", {
    description:
      "Your ClickUp connection expired. Reconnect, then try the action again.",
    action: {
      label: "Reconnect",
      onClick: () => {
        window.location.href = "/auth/login";
      },
    },
  });
  return true;
}
